import { Component, Inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../../common/take-until-destroy.decorator';
import { ScorecardDataService } from '../core/data.service';
import { Widget, WidgetType } from '../core/template-definition.model';
import { TranslationKeyMap } from '../scorecard.i18n';
import { CMPS_SCORECARD_WIDGET } from '../scorecard.metadata';
import { FyiMetric } from '../scorecard.model';

@Component({
    selector: 'cmps-scorecard-fyi-widget',
    templateUrl: './fyi-widget.component.html',
})
@TakeUntilDestroy()
export class ScFyiWidgetComponent implements OnInit {
    /** @private */ _fyiMetrics: FyiMetric[];

    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _collapsed: boolean;

    /** @private */ get _isLoadingData(): Observable<boolean> {
        return this._loadingData.asObservable();
    }

    private readonly _loadingData: BehaviorSubject<boolean>;

    public headerColour: string;
    public headerTextColour: string;

    constructor(
        private readonly _dataService: ScorecardDataService,
        @Inject(CMPS_SCORECARD_WIDGET) /** @private */ public _widget: Widget,
    ) {
        this._loadingData = new BehaviorSubject<boolean>(false);
        this.headerColour = _widget.headerColour;
        this.headerTextColour = _widget.headerTextColour;
    }

    ngOnInit(): void {
        this._dataService
            .observableForWidgetType<FyiMetric[]>(WidgetType.FYI_GRID)
            .pipe(
                tap((data) => {
                    this._fyiMetrics = data || [];
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
